import React, { Component, Fragment } from 'react';
import { observer, inject } from 'mobx-react';
import { withRouter } from "react-router";
import ImgView from 'components/common/FileController/ImgView';
import FileUpload from 'components/common/FileController/FileUpload';

import { notification, Button, Descriptions, Input, Checkbox, Table, Radio } from 'antd';
import { CaretUpOutlined, CaretDownOutlined } from '@ant-design/icons';

@inject('goodsInfoStore')
@observer
class GoodsDetail extends Component {
  state = {
    saveData: {
      gdCd: '',
      gdNm: '',
      gdSex: '',
      gdPrice: '',
      gdImgUrl: '',
      gdImgUrlInfo_fileId: null,
      gdImgUrlInfo_fileName: null,
      gdImgUrlInfo_physicalName: null,
      gdImgUrlInfo_serverSubPath: null,
      gdDetailUrl: '',
      gdDetailUrlInfo_fileId: null,
      gdDetailUrlInfo_fileName: null,
      gdDetailUrlInfo_physicalName: null,
      gdDetailUrlInfo_serverSubPath: null,
      gdMakeDate: '',
      gdEditDate: '',
      gdSizeList: []
    },
  };

  onChangValue = (dataVal, dataNm) => {
    if (dataNm === 'gdPrice') {
      dataVal = dataVal.replace(/[^0-9]/g, "");
    }

    this.setState({
      saveData: {
        ...this.state.saveData,
        [dataNm]: dataVal
    }});
  };

  setData = (mode) => {
    this.props.goodsInfoStore.onViewMode(mode);
    if (mode === 'detail' || mode === 'add') {
      this.setState({
        saveData: {
          gdCd: '',
          gdNm: '',
          gdSex: '',
          gdPrice: '',
          gdImgUrl: '',
          gdImgUrlInfo_fileId: null,
          gdImgUrlInfo_fileName: null,
          gdImgUrlInfo_physicalName: null,
          gdImgUrlInfo_serverSubPath: null,
          gdDetailUrl: '',
          gdDetailUrlInfo_fileId: null,
          gdDetailUrlInfo_fileName: null,
          gdDetailUrlInfo_physicalName: null,
          gdDetailUrlInfo_serverSubPath: null,
          gdMakeDate: '',
          gdEditDate: '',
          gdSizeList: []
      }});
    } else if (mode === 'mod') {
      this.setState({
        saveData: {
          ...this.state.saveData,
          ...this.props.goodsInfoStore.detailData,
      }});
    } else if (mode === 'list') {
      this.props.goodsInfoStore.disGoodsList();
    }
  };

  onSave = () => {
    if (this.state.saveData.gdNm === '') {
      notification.warning({placement: 'bottomLeft', message: `상품명을 입력해주세요.`, duration: 2});
      return false;
    }

    if (this.state.saveData.gdSex === '') {
      notification.warning({placement: 'bottomLeft', message: `성별을 선택해주세요.`, duration: 2});
      return false;
    }
    
    if (this.state.saveData.gdPrice === '') {
      notification.warning({placement: 'bottomLeft', message: `판매가를 입력해주세요.`, duration: 2});
      return false;
    }

    // if (this.state.saveData.gdImgUrl === '') {
    //   notification.warning({placement: 'bottomLeft', message: `상품이미지를 선택해주세요.`, duration: 2});
    //   return false;
    // }

    // if (this.state.saveData.gdDetailUrl === '') {
    //   notification.warning({placement: 'bottomLeft', message: `상품상세이미지를 선택해주세요.`, duration: 2});
    //   return false;
    // }

    if (this.props.goodsInfoStore.viewMode === 'add') {
      this.props.goodsInfoStore.addGoodsInfo(this.state.saveData);
    } else if (this.props.goodsInfoStore.viewMode === 'mod') {
      this.props.goodsInfoStore.modGoodsInfo(this.state.saveData);
    }
  };

  handleReset = () => {
    this.setState({
      saveData: {
        ...this.state.saveData,
        gdSizeList: (this.props.goodsInfoStore.detailData !== undefined && this.props.goodsInfoStore.detailData !== null
                && this.props.goodsInfoStore.detailData.gdSizeList !== undefined && this.props.goodsInfoStore.detailData.gdSizeList !== null)
                ? this.props.goodsInfoStore.detailData.gdSizeList : []
    }});
  };

  handleAdd = () => {
    let newData = {
      stKey: 'new' + Date.now(),
      stGdCd: this.state.saveData.gdCd,
      stSize: '',
      stCnt: 0
    };
    this.setState({
      saveData: {
        ...this.state.saveData,
        gdSizeList: [
          ...this.state.saveData.gdSizeList,
          newData,
        ]
      }
    });
  };
  
  handleDelete = key => {
    this.setState({ 
      saveData: {
        ...this.state.saveData,
        gdSizeList: this.state.saveData.gdSizeList.filter(item => item.stKey !== key)
      }
    });
  };

  handleChange = (type, name, item, record, index) => {
    const funcChange = (value) => {
      const newData = [...this.state.saveData.gdSizeList];
      newData.splice(index, 1, {
        ...record,
        [name]:value,
      });
      this.setState({
        saveData: {
          ...this.state.saveData,
          gdSizeList: newData
        }
      });
    };

    if (type === 'Input') {
      return (
        <Input
          disabled={this.props.goodsInfoStore.viewMode === 'detail' ? true : false}
          value={item}
          onChange={(e)=>funcChange(e.target.value)}
          style={{ width: 200 }}
        />
      )
    } else if (type === 'InputNumber') {
      return (
        <Input
          disabled={this.props.goodsInfoStore.viewMode === 'detail' ? true : false}
          value={item}
          onChange={(e)=>{
            let value = e.target.value;
            value = value.toString().replace(/[^0-9]/g, "");
            funcChange(value);
          }}
          style={{ width: 200 }}
        />
      )
    } else if (type === 'Checkbox') {
      return (
        <Checkbox
          disabled={this.props.goodsInfoStore.viewMode === 'detail' ? true : false}
          checked={item === 'Y' ? true : false}
          onChange={(e)=>funcChange(e.target.checked ? "Y" : "N")}
        />
      )
    }
  };
  
  handleOrderChange = (type, item, record, index) => {
    const newData = [...this.state.saveData.gdSizeList];

    if (type === 'up') {
      newData.splice(index, 1, newData[index-1]);
      newData.splice(index-1, 1, record);
      
    } else if (type === 'down') {
      newData.splice(index, 1, newData[index+1]);
      newData.splice(index+1, 1, record);
    }

    this.setState({
      saveData: {
        ...this.state.saveData,
        gdSizeList: newData
      }
    });
  };

  render() {
    const { viewMode, detailData } = this.props.goodsInfoStore;
    const { ceType } = this.props;
    const { saveData } = this.state;
    const columns = [
      { title: '삭제', dataIndex: '', width: '20%', align: 'center',
        render: (item, record) => { return(
          <Fragment key={record.key}>
            <Button 
              type="primary"
              onClick={() => this.handleDelete(record.stKey)}
            >삭제</Button>
          </Fragment>
        )}
      },
      { title: '순서변경', dataIndex: '', width: '20%', align: 'center',
        render: (item, record, idx) => { return(
          <div key={record.key}>
            {idx !== 0 &&
              <Button
                style={{ marginRight: 8 }}
                onClick={() => this.handleOrderChange('up', item, record, idx)}
              ><CaretUpOutlined /></Button>
            }
            {idx !== (this.state.saveData.gdSizeList.length-1) &&
              <Button
                onClick={() => this.handleOrderChange('down', item, record, idx)}
              ><CaretDownOutlined /></Button>
            }
          </div>
        )}
      },
      { title: '사이즈', dataIndex: 'stSize', width: '20%', align: 'center',
        render: (item, record, index) => { return(
          this.handleChange('Input', 'stSize', item, record, index)
        )}
      },
      { title: '현재재고수량', dataIndex: 'orgStCnt', width: '20%', align: 'center',
        render: (item, record, index) => { return(
          (item !== undefined && item !== null) ? item : record.stCnt
        )}
      },
      { title: '변경재고수량', dataIndex: 'stCnt', width: '20%', align: 'center',
        render: (item, record, index) => { return(
          this.handleChange('InputNumber', 'stCnt', item, record, index)
        )}
      }
    ];
    return (
      <Fragment>
        <div className="button-group">
          <h2>상품 정보
            {viewMode === 'detail' && <Fragment> 상세보기</Fragment>}
            {viewMode === 'add' && <Fragment> 추가</Fragment>}
            {viewMode === 'mod' && <Fragment> 수정</Fragment>}
          </h2>
          {(ceType === process.env.REACT_APP_TYPE_YUJIN) 
            ? (
              <div className="button-right">
                {viewMode === 'detail'
                ? <ul>
                    <li><Button type="primary" onClick={()=>this.setData('list')}>목록</Button></li>
                    <li><Button type="primary" onClick={()=>this.setData('mod')}>수정</Button></li>
                  </ul>
                : <ul>
                    <li><Button type="primary" onClick={()=>this.onSave()}>저장</Button></li>
                    <li><Button type="primary" onClick={()=>this.setData(viewMode === 'add' ? 'list' : 'detail')}>취소</Button></li>
                  </ul>
                }
              </div>
            ) : (
              <div className="button-right">
                <ul>
                    <li><Button type="primary" onClick={()=>this.setData('list')}>목록</Button></li>
                  </ul>
              </div>
            )
            
          }
        </div>
        <div className="table_th_W">
          <Descriptions bordered>
            <Descriptions.Item label="상품명 *" span={2}>
              {viewMode === 'detail'
              ? (((detailData?.gdNm) &&
                detailData?.gdNm.split(`\n`).map((item, idx)=>{
                  return (
                    <Fragment key={idx}>
                      {item}
                      {detailData.gdNm.split(`\n`).length > idx+1 && <br />}
                    </Fragment>
                )})) || '')
              : <Input.TextArea
                  style={{minHeight: 80, maxHeight: 80}}
                  maxLength={45}
                  autoSize={false}
                  value={saveData.gdNm}
                  onChange={(e)=>this.onChangValue(e.target.value, 'gdNm')}
                />
              }
            </Descriptions.Item>
            <Descriptions.Item label="성별 *" span={1}>
              <Radio.Group
                disabled={viewMode === 'detail' ? true : false}
                onChange={(e)=>this.onChangValue(e.target.value, 'gdSex')} 
                value={viewMode === 'detail' 
                  ? (detailData !== null && detailData.gdSex !== undefined && detailData.gdSex !== null) ? detailData.gdSex : ''
                  : (saveData.gdSex !== undefined && saveData.gdSex !== null) ? saveData.gdSex : ''
                }
              >
                <Radio value={'M'}>남</Radio>
                <Radio value={'F'}>여</Radio>
                <Radio value={'A'}>공용</Radio>
              </Radio.Group>
            </Descriptions.Item>
            <Descriptions.Item label="가격 *" span={3}>
              {viewMode === 'detail'
              ? (detailData !== null && detailData.gdPrice !== undefined && detailData.gdPrice !== null && 
                detailData.gdPrice !== "" && detailData.gdPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","))
              : <Input
                  style={{ width: '20%' }}
                  value={saveData.gdPrice === "" ? saveData.gdPrice : saveData.gdPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                  onChange={(e)=>this.onChangValue(e.target.value, 'gdPrice')}
                />
              }
              원
            </Descriptions.Item>
            <Descriptions.Item label="상품이미지" span={2}> 
              {viewMode === 'detail'
              ? detailData !== null && detailData.gdImgUrlInfo_fileId !== undefined && detailData.gdImgUrlInfo_fileId !== null &&
              <Fragment>
                <ImgView
                  fileInfo={{
                    fileId: detailData.gdImgUrlInfo_fileId,
                    fileName: detailData.gdImgUrlInfo_fileName,
                    physicalName: detailData.gdImgUrlInfo_physicalName,
                    serverSubPath: detailData.gdImgUrlInfo_serverSubPath,
                  }}
                  width={100}
                  height={100}
                />
                {detailData.gdImgUrlInfo_fileName}
              </Fragment>
              : 
              <Fragment>
                <div style={{float:'right',color: '#f00'}}>정사각형 사이즈만 업로드 가능합니다.</div> 
                <FileUpload
                  imgSizeCheck={true}
                  fileType={'img'}
                  onFileInfo={(fileData)=>{
                    this.setState({
                      saveData: {
                        ...saveData,
                        gdImgUrl: fileData.fileId,
                        gdImgUrlInfo_fileId: fileData.fileId,
                        gdImgUrlInfo_fileName: fileData.fileName,
                        gdImgUrlInfo_physicalName: fileData.physicalName,
                        gdImgUrlInfo_serverSubPath: fileData.serverSubPath,
                      }
                    });
                  }}
                />
                
                {saveData.gdImgUrlInfo_fileId !== undefined && saveData.gdImgUrlInfo_fileId !== null &&
                <Fragment>
                  <br />
                  <ImgView
                    fileInfo={{
                      fileId: saveData.gdImgUrlInfo_fileId,
                      fileName: saveData.gdImgUrlInfo_fileName,
                      physicalName: saveData.gdImgUrlInfo_physicalName,
                      serverSubPath: saveData.gdImgUrlInfo_serverSubPath,
                    }}
                    width={100}
                    height={100}
                  />{saveData.gdImgUrlInfo_fileName}
                </Fragment>
                }
              </Fragment>
              }
            </Descriptions.Item>
            <Descriptions.Item label="상세이미지" span={1}>
              {viewMode === 'detail'
              ? detailData !== null && detailData.gdDetailUrlInfo_fileId !== undefined && detailData.gdDetailUrlInfo_fileId !== null &&
              <Fragment>
                <ImgView
                  fileInfo={{
                    fileId: detailData.gdDetailUrlInfo_fileId,
                    fileName: detailData.gdDetailUrlInfo_fileName,
                    physicalName: detailData.gdDetailUrlInfo_physicalName,
                    serverSubPath: detailData.gdDetailUrlInfo_serverSubPath,
                  }}
                  width={100}
                  height={100}
                />
                {detailData.gdDetailUrlInfo_fileName}
              </Fragment>
              : 
              <Fragment>
                <FileUpload
                  fileType={'img'}
                  onFileInfo={(fileData)=>{
                    this.setState({
                      saveData: {
                        ...saveData,
                        gdDetailUrl: fileData.fileId,
                        gdDetailUrlInfo_fileId: fileData.fileId,
                        gdDetailUrlInfo_fileName: fileData.fileName,
                        gdDetailUrlInfo_physicalName: fileData.physicalName,
                        gdDetailUrlInfo_serverSubPath: fileData.serverSubPath,
                      }
                    });
                  }}
                />
                {saveData.gdDetailUrlInfo_fileId !== undefined && saveData.gdDetailUrlInfo_fileId !== null &&
                <Fragment>
                  <br />
                  <ImgView
                    fileInfo={{
                      fileId: saveData.gdDetailUrlInfo_fileId,
                      fileName: saveData.gdDetailUrlInfo_fileName,
                      physicalName: saveData.gdDetailUrlInfo_physicalName,
                      serverSubPath: saveData.gdDetailUrlInfo_serverSubPath,
                    }}
                    width={100}
                    height={100}
                  />
                  {saveData.gdDetailUrlInfo_fileName}
                </Fragment>
                }
              </Fragment>
              }
            </Descriptions.Item>
          </Descriptions>
        </div>
        
        <div className="button-group">
          <h2>▶ 상품사이즈 및 재고</h2>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <h4 style={{ color: 'blue' }}>
            총 재고수량: &nbsp;&nbsp;
            {(detailData !== null && detailData.stCntTotal !== undefined && detailData.stCntTotal !== null && detailData.stCntTotal !== "")
            ? detailData.stCntTotal.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            : 0} &nbsp; 개
          </h4>
          {viewMode !== 'detail' &&
          <div className="button-right">
            <ul>
              <li><Button onClick={this.handleAdd}>사이즈추가</Button></li>
              <li><Button onClick={this.handleReset}>초기화</Button></li>
            </ul>
          </div>
          }
        </div>
        
        <Table
          rowKey={(record)=>record.stKey}
          columns={viewMode === 'detail' ? columns.slice(2, columns.length-1) : columns} 
          dataSource={viewMode === 'detail' 
                ? (detailData !== null && detailData.gdSizeList !== undefined && detailData.gdSizeList !== null) ? detailData.gdSizeList : []
                : (saveData.gdSizeList !== undefined && saveData.gdSizeList !== null) ? saveData.gdSizeList : []
          }
          pagination={false}
        />

      </Fragment>
    );
    
  }
}

export default withRouter(GoodsDetail);
